import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import { withRtl } from '../hoc';
import style from './LinkCard.scss'; // eslint-disable-line css-modules/no-unused-class
import CaretRightIcon from '../icons/CaretRight';
import history from '../../history';

class LinkCard extends Component {
  static propTypes = {
    headingText: PropTypes.string.isRequired,
    ariaLabel: PropTypes.string.isRequired,
    helpText: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.isExternal = !props.href.search(/^http[s]?:\/\//);
  }

  handleClick = event => {
    const { href } = this.props;
    if (!this.isExternal) {
      event.preventDefault();
      history.push(href);
    }
  };

  render() {
    const {
      //
      headingText,
      ariaLabel,
      helpText,
      href,
    } = this.props;

    return (
      <a
        role="button"
        className={style.linkCard}
        href={href}
        aria-label={ariaLabel}
        onClick={this.handleClick}
        target={this.isExternal ? '_blank' : '_self'}
      >
        <div className={style.linkCardText}>
          <p className={style.heading}>{headingText}</p>
          <p className={style.help}>{helpText}</p>
        </div>
        <div className={style.blueLink}>
          <CaretRightIcon size={12} fill="#fff" />
        </div>
      </a>
    );
  }
}

export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
)(LinkCard);
